import React from 'react';
import PropTypes from 'prop-types';

export default class PageIntro extends React.PureComponent {
  static propTypes = {
    entry: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    children: PropTypes.node,
  }

  state = {
    entry: this.props.entry,
    data: this.props.data,
    visited: false,
    pageData: null,
  };

  componentDidMount() {
    // Process data when component mounts if available
    if (this.state.data && this.state.data.length > 0) {
      this.processPageData();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if data or loading props have been updated
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data }, () => {
        if (this.state.data && this.state.data.length > 0) {
          this.processPageData();
        }
      });
    }
  }

  processPageData() {
    const data = this.state.data;
    if (!data || data.length === 0) return;
    
    const page = data.filter(entry => entry.sys.id === this.state.entry);
    if (page && page.length > 0) {
      this.setState({ pageData: page[0].fields });
    }
  }

  render() {
    // Only try to render data if it's available
    const { pageData } = this.state;
    const { loading } = this.props;
    
    // Add loading state while waiting for data
    if (loading || !pageData) {
      return (
        <section>
          <div className="intro">
            <div className="intro-inner">
              <h1 className="intro-title">Loading...</h1>
            </div>
          </div>
        </section>
      );
    }
    
    return (
      <section>
        <div className="intro">
          <div className="intro-inner">
            <h1 className="intro-title">{pageData.title}</h1>
            <p className="intro-text">{pageData.intro}</p>
            {this.props.children}
          </div>
        </div>
      </section>
    );
  }
}
